module.exports = __webpack_public_path__ + "img/Journey 2 Kado Gif-Dark Purple.9ee2b605.gif";